import { render, staticRenderFns } from "./wheelSelector.vue?vue&type=template&id=7205766b&scoped=true"
import script from "./wheelSelector.vue?vue&type=script&lang=js"
export * from "./wheelSelector.vue?vue&type=script&lang=js"
import style0 from "./wheelSelector.vue?vue&type=style&index=0&id=7205766b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7205766b",
  null
  
)

export default component.exports